import { useEffect, useState } from "react";
import Tabs from "../../../components/tabs/Tabs";
import EventOverview from "./eventOverview/EventOverview";
import PlanningForm from "./PlanningForm/PlanningForm";
import Budget from "./Budget/Budget";
import Checklist from "./Checklist/Checklist";
import InspirationalGallery from "../InspirationalGallery/InspirationalGallery";
import Gallery from "./Gallery/Gallery";
import { useLocation, useNavigate } from "react-router-dom";
import { BoxTabs } from "../../../components/AntdTab/AntdTab";
import Timeline from "./Timeline/Timeline";
import { roles } from "../../../config/roles";
import SubContacts from "../Vendors/subContacts/SubContacts";
import { SubContactDetails, WeddingWallClient, WeddingWebsite } from "..";
import Storage from "../../../utills/AsyncStorage";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
import { useDispatch, useSelector } from "react-redux";
import { VendorTemplates } from "../../VendorsScreens";
import { PlanningTemplatesMiddleware } from "../../../Store/Middlewares/PlanningTemplatesMiddleware";
import Modal from "../../../components/modal/Modal";
import styles from "./EventDetail.module.css";
import { SubmitButton, TextComponent } from "../../../components";
import { Space } from "antd";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import Dropdown from "../../../components/dropdowns/Dropdown";
const EventDetail = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  // console.log("stateeeeeeOver", state);
  const [isTemp, setisTemp] = useState(false);
  const [SelectedTemplate, setTemplates] = useState("Select Template");
  const TemplatesList = useSelector(
    (state) => state.PlanningTemplatesReducer?.PlanningTemplates,
  );
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);

  // console.log("evetDetails===========>>>", state);
  // console.log("TemplatesList===========>>>", TemplatesList);
  // console.log("SelectedTemplate===========>>>", SelectedTemplate);
  // console.log("EventDetails===========>>>", EventDetails);

  const role = Storage.getERole("@role");
  const dispatch = useDispatch();

  const createTemplate = () => {
    setisTemp(false);
    let eventData = {
      event_id: EventDetails?.id,
      planning_template_id: SelectedTemplate?.id,
    };
    dispatch(PlanningTemplatesMiddleware.associatePlanningTemplate(eventData))
      .then((data) => {
        navigate("/events/eventDetail/templates/vendor", {
          state: { eventData: state?.eventData, screenType: "event" },
        });
      })
      .catch(() => {});
  };
  // useEffect(() => {
  //   dispatch(EventMiddleware.getEventDetails({ id: state?.eventData?.id }));
  // }, []);

  const itemsForClient = [
    {
      key: "1",
      label: "Overview",
      headerTitle: "Event Details",
      children: <EventOverview />,
      // onClick: () => {
      //   navigate(".", { state: { headrTitle: "Event Detail" } });
      // },
    },
    {
      key: "2",
      label: "Planning Form",
      children: <PlanningForm />,
    },
    {
      key: "3",
      label: "Budget",
      children: <Budget />,
    },
    {
      key: "4",
      label: "Wedding Website",
      children: <WeddingWebsite />,
    },
    {
      key: "5",
      label: "Wedding Wall",
      children: <WeddingWallClient />,
    },
    // {
    //   key: "6",
    //   label: "Guests",
    //   children: null,
    //   onClick: () => {
    //     navigate("/events/eventDetail/guests", {
    //       state: { headrTitle: "Guests", eventData: state?.eventData },
    //     });
    //   },
    // },
    {
      key: "6",
      label: "Guests",
      children: null,
      onClick: () => {
        navigate("/events/guestDetails", {
          state: { headrTitle: "Guests", eventData: state?.eventData },
        });
      },
    },
    {
      key: "7",
      label: "Vendors",
      children: null,
      onClick: () => {
        navigate("/findVendors/EventVendors", {
          state: { headrTitle: "Vendors", eventData: state?.eventData },
        });
      },
    },
    {
      key: "8",
      label: "My Wedding Calendar",
      children: null,
      onClick: () => {
        navigate("/reminder", {
          state: {
            headrTitle: "My Wedding Calendar",
            eventData: state?.eventData,
          },
        });
      },
    },
    {
      key: "9",
      label: "checklist / To Do's",
      children: <Checklist />,
    },
    {
      key: "10",
      label: "Inspirational Gallery",
      children: <InspirationalGallery />,
    },
    {
      key: "11",
      label: "Gallery",
      children: <Gallery />,
    },
    {
      key: "12",
      label: "Timeline",
      children: <Timeline />,
      headerTitle: "Event Details",
    },
  ];

  const itemsForVendor = [
    {
      key: "1",
      label: "Overview",
      headerTitle: "Event Details",
      children: <EventOverview />,
    },
    {
      key: "2",
      label: "Vendors",
      children: null,
      onClick: () => {
        navigate("/findVendors/EventVendors", {
          state: { headrTitle: "Vendors", eventData: state?.eventData },
        });
      },
    },
    {
      key: "3",
      label: "Checklist / To-Do's",
      children: <Checklist />,
    },
    // {
    //   key: "2",
    //   label: "Vendors",
    //   children: <SubContacts />,
    // },
    {
      key: "4",
      label: "Inspirational Gallery",
      children: <InspirationalGallery />,
    },

    {
      key: "5",
      label: "Planning Forms",
      children: null,
      onClick: () => {
        if (EventDetails?.template) {
          navigate("/events/eventDetail/templates/vendor", {
            state: {
              eventData: state?.eventData,
              screenType: "event",
              headerTitle: "Planning Forms",
            },
          });
        } else {
          if (TemplatesList?.length > 0 && role == roles.vendor) {
            setisTemp(true);
          } else {
            dispatch(
              PlanningTemplatesMiddleware.getPlanningTemplates({
                event_id: false,
              }),
            )
              .then(() => {
                if (role == roles.vendor) {
                  setisTemp(true);
                }
              })
              .catch((err) => {
                setisTemp(false);
              });
          }
        }
      },
    },
    {
      key: "6",
      label: "My Wedding Calender",
      children: null,
      onClick: () => {
        navigate("/reminder", {
          state: {
            eventData: state?.eventData,
            headrTitle: "My Wedding Calender",
          },
        });
      },
    },
    {
      key: "7",
      label: "Timeline",
      children: <Timeline />,
      headerTitle: "Event Details",
    },
  ];

  return (
    <>
      <BoxTabs
        items={
          role === roles.vendor || role === roles.staff
            ? itemsForVendor
            : itemsForClient
        }
        changeHeaderOnTab={true}
        activeKey={state?.activeKey}
        destroyOnBlur
      />
      <Modal
        isModalOpen={isTemp}
        setIsModalOpen={setisTemp}
        closable={true}
        className={styles.modal}
      >
        <div className={styles.modalCont}>
          <AiOutlineExclamationCircle className={styles.modalIcon} />
          <TextComponent
            text={"Planning Forms not assign yet."}
            textClass={styles.modalHeading}
          />

          <Dropdown
            label="Planning Forms"
            name="Planning Forms"
            placeholder="Select Planning Forms"
            className={styles.dropdownInput}
            object={TemplatesList?.map((data) => ({
              ...data,
              name: data?.title,
            }))}
            onChange={(e) => setTemplates(e)}
          />
          <SubmitButton
            title="Assign Planning Forms"
            btnClass={styles.modalBtnTemplate}
            onClick={createTemplate}
            disabled={!SelectedTemplate?.id}
          />
          <SubmitButton
            title="Go To Planning Forms"
            btnClass={styles.modalBtnTemplate}
            onClick={() => {
              navigate("/templates/mytemplates");

              // navigate("/events/eventDetail/templates/vendor", {
              //   state: { eventData: state?.eventData, screenType: "event" },
              // });
            }}
          />
        </div>
      </Modal>
    </>
  );
};

export default EventDetail;
